import { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Profile from './Profile';
// import PasswordChange from './PasswordChange';
import Page from '../../components/Page';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { useAppSelector } from '../../store';
import { Box } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Grid mt={1}>{children}</Grid>}
    </div>
  );
}

const Index: React.FC = () => {
  const userProfile = useAppSelector((state) => state.auth.user);
  const [value, setValue] = useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Page title={'Profile'}>
      <Container maxWidth='xl'>
        <HeaderBreadcrumbs
          heading={'Update Profile'}
          links={[
            { name: 'Dashboard', href: '/' },
            // { name: 'Profile', href: '/user/profile' },
            {
              name: `${userProfile.firstName} ${userProfile.lastName}`,
              href: '/user/profile',
            },
          ]}
        />
        <Box
          sx={{
            maxWidth: { xs: 550, sm: 850, md: 1150, lg: 1500 },
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons={true}
            aria-label='scrollable auto tabs example'
          >
            <Tab label={'Update Profile'} />
            {/* <Tab label={'Change Password'} /> */}
          </Tabs>
        </Box>
        <TabPanel
          value={value}
          index={0}
        >
          <Profile />
        </TabPanel>
        {/* <TabPanel
          value={value}
          index={1}
        >
          <PasswordChange />
        </TabPanel> */}
      </Container>
    </Page>
  );
};

export default Index;
